// extracted by mini-css-extract-plugin
module.exports = {"progress":"Progress_progress__PXGSa"};